import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';

type FindProviderItem = {
  Address: string;
  City: string;
  County: string;
  FirstName: string;
  Identification: string;
  LastName: string;
  ProviderCode: string;
  ProviderImage: string;
  ProviderName: string;
  Province: string;
};

type SearchProviderResultItem = {
  id: string;
  name: string;
  fullName: string;
  county: string;
  city: string;
  imageUrl: string;
  code: string;
};

function getSearchKey(type: 'شناسه' | 'کد ملی' | 'مشخصات'): 'ProviderCode' | 'NationalCode' | 'Name' {
  if (type === 'شناسه') return 'ProviderCode';
  if (type === 'کد ملی') return 'NationalCode';
  return 'Name';
}

function getSearchValue(type: 'شناسه' | 'کد ملی' | 'مشخصات', value: string): string {
  if (type === 'شناسه') return parseInt(value.replace('RNS-1', ''), 10).toString();

  return value;
}

function parseFindProviderItem(value: FindProviderItem): SearchProviderResultItem {
  return {
    id: value.Identification,
    name: value.ProviderName,
    fullName: [value.FirstName, value.LastName].join(' '),
    imageUrl: value.ProviderImage,
    city: value.City,
    county: value.County,
    code: value.ProviderCode,
  };
}

export default function useSearchProvider({ type, value }: { type: 'شناسه' | 'کد ملی' | 'مشخصات'; value: string }) {
  const [_, { data, ...result }] = useFetchCallType<FindProviderItem[]>('FindProvider', {
    // skip: true,
    params: `SearchKey=${getSearchKey(type)}&SearchValue=${getSearchValue(type, value)}`,
  });
  console.log(`SearchKey=${getSearchKey(type)}&SearchValue=${getSearchValue(type, value)}`);
  console.log(result);
  return {
    ...result,
    data: data?.map(parseFindProviderItem),
  };
}
